module.exports = __webpack_public_path__ + "img/20190314_084716 (1).ffd1f2cf.jpg";